import { Col, Container, Image, Row } from "react-bootstrap";
import * as Icon from "react-bootstrap-icons";
import Spacer from "./Spacer";
export default function Footer(props: { teaser?: boolean }) {

	const teaserClass = props.teaser ? "black" : "";
	return (
		<footer className={`footer ${teaserClass}`}>
			<Row
				xs={2} sm={2}
				md={4}
				className=" justify-content-md-center gx-0"
			>
				<Col className="footer-distance">
					<p className="footer-bold">Legislation and regulations</p>
					<a href="/legal">Declaration of conformity</a> <br />
					<a href="/terms">Terms & conditions</a> <br />
					<a href="/privacy">Privacy statement</a> <br />
				</Col>
				<Col>
					<p className="footer-bold">Socials</p>
					<a href="https://www.instagram.com/earsonly_/" style={{borderBottom:"none"}} target="_blank" rel="noopener noreferrer">
						<Image src="/images/icons/instagram.svg" className="svg-hover" style={{ paddingRight: "2em", paddingTop: "1em" }} />
					</a>
					<a href="https://www.linkedin.com/company/earsonly/" style={{borderBottom:"none"}} target="_blank" rel="noopener noreferrer">

						<Image src="/images/icons/linkedin.svg" className="svg-hover" style={{ paddingTop: "1em" }} />
					</a>

				</Col>
				<Col>
					<p className="footer-bold">Visit</p>
					<address>
						Overcingellaan 7 <br />
						9401 LA Assen <br />
						The Netherlands
					</address>
				</Col>
			</Row>
			<Row className="gx-0">
				{" "}
				<Col className="footer-earsonly ">&copy; EarsOnly 2026</Col>
			</Row>
		</footer>
	);
}
